import { render, staticRenderFns } from "./SubscribeForm.vue?vue&type=template&id=255fe816&scoped=true&"
import script from "./SubscribeForm.vue?vue&type=script&lang=js&"
export * from "./SubscribeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255fe816",
  null
  
)

export default component.exports